"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon20Solid = forwardRef_1.forwardRef('SearchLoupeIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.129a7.874 7.874 0 1 0 4.717 14.18l3.364 3.363a1.125 1.125 0 0 0 1.59-1.591l-3.363-3.364A7.874 7.874 0 0 0 9 1.13ZM3.376 9.003a5.624 5.624 0 1 1 11.248 0 5.624 5.624 0 0 1-11.248 0Z" })));
});
